import { render } from "./Emptyview.vue?vue&type=template&id=69d887b0"
import script from "./Emptyview.vue?vue&type=script&lang=js"
export * from "./Emptyview.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zsrb/Documents/中山日报/2025/zsrb-news-detail/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__